<template>
    <b-modal
            :visible="showModal === 'closeOrder'"
            @show="initModal"
            @hidden="hideCloseModal"
            :lazy="true"
    >
        <div slot="modal-title">
            <h4 v-if="order">Закрыть заказ № {{order.id}}</h4>
        </div>
        <loading v-if="loading" :size="3" message="Заказ закрывается..."></loading>
        <form v-else сlass="form-horizontal" @submit.prevent="close">
            <div class="form-group row" :class="{ 'has-danger': $v.sum.$error }">
                <label class="col-6 form-control-label" for="sum-input">Общая сумма заказ-наряда</label>
                <div class="col-6">
                    <input type="number" rel="focusThis" v-focus @input="$v.sum.$touch()" @keyup.enter="close" id="sum-input" v-model="sum" class="form-control" placeholder="Сумма по заказ-наряду">
                    <span class="small help-block text-danger" v-if="$v.sum.$error">Сумма заказ-наряда дожна быть больше 0</span>
                </div>
            </div>
            <div class="form-group row" :class="{ 'has-danger': $v.profit.$error }">
                <label class="col-6 form-control-label" for="profit-input">Комиссия с заказа</label>
                <div class="col-6">
                    <input type="number" @input="$v.profit.$touch()" @keyup.enter="close" id="profit-input" v-model="profit" class="form-control" placeholder="Комиссия по заказ-наряду">
                    <span class="small help-block text-danger" v-if="$v.profit.$error">Комиссия должна быть больше 0</span>
                </div>
            </div>
            <button type="submit" style="display: none"></button>
        </form>
        <div slot="modal-footer">
            <b-btn v-if="!loading" @click.prevent="hideCloseModal">Отменить</b-btn>
            <b-btn v-if="!loading" variant="success" :class="{ 'disabled': $v.sum.$invalid || $v.profit.$invalid }" :disabled=" $v.sum.$invalid || $v.profit.$invalid" @click.prevent="close">Закрыть заказ</b-btn>
        </div>
    </b-modal>
</template>
<script>
  import { numeric, required, minValue } from 'vuelidate/lib/validators'
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  export default {
    computed: mapState({
      showModal: state => state.orderStore.showModal,
      order: state => state.orderStore.editOrder
    }),
    directives: {
      focus: {
        inserted: function (el) {
          el.focus()
        }
      }
    },
    data () {
      return {
        sum: null,
        profit: null,
        loading: false
      }
    },
    methods: {
      close () {
        this.loading = true
        this.$store.dispatch('closeOrder', {
          sum: this.sum,
          profit: this.profit,
          orderId: this.order.id
        }).then((data) => {
          this.sum = null
          this.profit = null
          this.loading = false
          this.$store.commit('SET_SHOW_ORDER_MODAL', null)
          this.addToast({
            text: 'Заказ успешно закрыт',
            type: 'success',
            dismissAfter: 3000
          })
        }).catch((error) => {
          this.loading = false
          this.addToast({
            text: 'Произошла ошибка при закрытии заказа:' + error,
            type: 'danger',
            dismissAfter: 3000
          })
        })
      },
      hideCloseModal () {
        this.$store.dispatch('setEditOrder', null)
        this.$store.commit('SET_SHOW_ORDER_MODAL', null)
      },
      initModal () {
        this.sum = this.order.sum
        this.profit = this.order.profit
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    validations: {
      sum: {
        numeric,
        required,
        minValue: minValue(0)
      },
      profit: {
        numeric,
        required,
        minValue: minValue(0)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalCloseOrder.vue?2bcc4ed2